import { splitPatterns } from '..';
import { checkMultiplet } from './checkMultiplet';
/**
 * check the input string corresponds to a composed pattern like dt or dd. it splits into indivitual patterns and use checkMultiplet function.
 * @param multiplicity - pattern name or abbreviation.
 * @param rejected - list of patterns that should not match with any pattern. e.g 'dt' as input will return false if rejected = ['t'].
 */
export function checkMultiplicity(multiplicity, rejected = []) {
    // options to determine whether a massive (m), for example, should be considered as rejected multiplicity
    if (multiplicity === undefined || multiplicity.length === 0) {
        return false;
    }
    const multiplets = splitPatterns(multiplicity);
    const allIncluded = multiplets.join('').length === multiplicity.length;
    return (allIncluded &&
        multiplets.every((_multiplet) => checkMultiplet(_multiplet, rejected)));
}
//# sourceMappingURL=checkMultiplicity.js.map